import React from 'react';
import './Investors.css';

const Investors = () => (
  <div className="investors-container">
    <h2>For Investors</h2>
    <p>
      Learn about the AFFEERCE plan, investment opportunities, and how you can help transform the future.
    </p>
    <p>
      Expected returns, projected adoption, and B-corp benefits explained.
    </p>
    <p>
      Contact us at: <a href="mailto:info@affeerce.org">info@affeerce.org</a>
    </p>
    <a
      href="/AFFEERCE White Paper.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="whitepaper-button"
    >
      📄 View AFFEERCE White Paper
    </a>
  </div>
);

export default Investors;